import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";

import Page from "@/components/Page";
import Loading from "@/components/Loading";
import Breadcrumbs from "@/components/Breadcrumbs";
import MainActions from "@/components/MainActions";
import CardsContainer from "@/components/CardsContainer";
import CardsList from "@/components/CardsList";
import CardsTable from "@/components/CardsTable";
import VLFConfirmModal from "@/components/Modal/Confirm";

import {ClubAPI} from "@/api/club";

import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import {SUCCESSFUL_OPERATION, ERROR_OPERATION} from "@/utils/constants";
import {fetchData} from "@/utils/functions";

import "./index.scss";
import {useTranslation} from "react-i18next";

function ClubsPage(props) {
	const {handleNotification} = props;

	const navigate = useNavigate();
	const {t} = useTranslation();

	const [loading, setLoading] = useState(false);
	const [clubs, setClubs] = useState([]);

	const getClubs = async () => {
		setLoading && setLoading(true);
		try {
			const response = await ClubAPI.list();
			setClubs(response);
		} catch (error) {
			handleNotification && handleNotification(ERROR_OPERATION, "error");
		} finally {
			setLoading && setLoading(false);
		}
	};

	useEffect(() => {
		getClubs();
	}, []);

	const [id, setId] = useState();
	const [openHandleConfirm, setOpenHandleConfirm] = useState(false);

	const deleteClub = () => {
		fetchData(
			() => ClubAPI.delete(id),
			undefined,
			() => setLoading(true),
			() => {
				setOpenHandleConfirm(false);
				getClubs();
				handleNotification(SUCCESSFUL_OPERATION, "success");
			},
			() => {
				handleNotification(ERROR_OPERATION, "error");
				setLoading(false);
			},
		);
	};

	const listConfiguration = {
		data: clubs,
		onClick: (club) => navigate("/settings/clubs/" + club.id),
		title: (club) => club.name,
		actions: [
			{
				icon: <EditIcon />,
				variant: "outlined",
				title: "Modifica",
				onClick: (club) => navigate("/settings/clubs/" + club.id + "/edit"),
			},
			{
				icon: <DeleteIcon />,
				variant: "outlined",
				title: "Elimina",
				onClick: (club) => {
					setId(club.id);
					setOpenHandleConfirm(true);
				},
				color: "error",
			},
		],
	};

	const columns = [{label: t("name"), key: "name", align: "start"}];

	const headerActions = [
		{
			icon: <AddIcon />,
			title: "Nuovo club",
			onClick: () => navigate("/settings/clubs/new"),
		},
	];

	return (
		<Page>
			<Loading visible={loading} />
			<Breadcrumbs
				current="Club"
				actions={<MainActions actions={headerActions} />}
			/>
			<CardsContainer
				tableComponent={
					<CardsTable
						breadcrumbs
						configurationColumns={columns}
						data={clubs}
						fullWidth
						rowActions
						handleClick={(item) => navigate("/settings/clubs/" + item.id)}
						handleEdit={(item) =>
							navigate("/settings/clubs/" + item.id + "/edit")
						}
						handleDelete={(item) => {
							setId(item.id);
							setOpenHandleConfirm(true);
						}}
						defaultSortedField="name"
					/>
				}
				listComponent={
					<CardsList
						type="club"
						breadcrumbs
						listConfiguration={listConfiguration}
					/>
				}
			/>
			<VLFConfirmModal
				open={openHandleConfirm}
				confirm={deleteClub}
				close={() => setOpenHandleConfirm(false)}
			/>
		</Page>
	);
}

export default ClubsPage;
